import React from "react";
import { Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

// Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

// Pages
import Home from "./pages/Home";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import Forbidden from "./pages/Forbidden";
import LocalAreaPage from "./pages/LocalAreaPage";
import { LOCAL_PAGES } from "./localPagesData";

export default function App() {
  return (
    <HelmetProvider>
      <div className="flex min-h-screen flex-col bg-primary-50/30 text-primary-900 antialiased selection:bg-brand-500 selection:text-white">
        {/* Scroll restoration */}
        <ScrollToTop />

        {/* Header Navigation */}
        <Header />

        {/* Main Content Area */}
        <main className="flex-grow">
          <Routes>
            {/* Home Route */}
            <Route path="/" element={<Home />} />

            {/* Services Routes */}
            <Route path="/ydelser" element={<Services />} />
            <Route path="/ydelser/:slug" element={<ServiceDetail />} />

            {/* Direct friendly SEO URL for Totalrenovering */}
            <Route path="/totalrenovering" element={<ServiceDetail forceSlug="totalrenoveringer" />} />

            {/* Direct friendly SEO URL for Ombygning */}
            <Route path="/ombygning" element={<ServiceDetail forceSlug="ombygninger" />} />

            {/* Direct friendly SEO URL for Totalentreprise */}
            <Route path="/totalentreprise" element={<ServiceDetail forceSlug="totalentrepriser" />} />
            <Route path="/totalentrepriser" element={<ServiceDetail forceSlug="totalentrepriser" />} />

            {/* Projects Routes */}
            <Route path="/tidligere-projekter" element={<Projects />} />
            <Route path="/tidligere-projekter/horn-vinduesfabrik" element={<ProjectDetail />} />
            
            {/* Gallery Route */}
            <Route path="/galleri" element={<Gallery />} />

            {/* Direct route for Horn vinduesfabrik as a fallback/alias */}
            <Route path="/horn-vinduesfabrik" element={<ProjectDetail />} />

            {/* Contact Route */}
            <Route path="/kontakt" element={<Contact />} />

            {/* Hidden Local Area SEO Landing Pages */}
            <Route path="/toemrer-hoejbjerg" element={<LocalAreaPage page={LOCAL_PAGES["toemrer-hoejbjerg"]} />} />
            <Route path="/toemrer-viby" element={<LocalAreaPage page={LOCAL_PAGES["toemrer-viby"]} />} />
            <Route path="/toemrer-skanderborg" element={<LocalAreaPage page={LOCAL_PAGES["toemrer-skanderborg"]} />} />
            <Route path="/toemrer-maarslet" element={<LocalAreaPage page={LOCAL_PAGES["toemrer-maarslet"]} />} />
            <Route path="/toemrer-odder" element={<LocalAreaPage page={LOCAL_PAGES["toemrer-odder"]} />} />

            {/* Error Pages */}
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </HelmetProvider>
  );
}
